import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as mainActions,
} from '../../../../redux/modules/main';

import RightButtonsView from './RightButtonsView';

// Types
import type {
  $State,
} from '../../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './RightButtonsView';

const mapStateToProps = ({
  main,
}: $State): $StateProps => ({
  main,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  // setLanguage: (params) => dispatchAction(
  //   mainActions.setLanguage(params),
  // ),
  setStart: (params) => dispatchAction(
    mainActions.setStart(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(RightButtonsView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
